export const useStyles = (theme) => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up(960)]: {
      padding: 20,
      display: "flex",
      flexDirection: "column",
    },
  },
  sectionMobile: {
    display: "none",
    [theme.breakpoints.down(960)]: {
      display: "flex",
    },
  },
  root: {
    padding: 10,
    minHeight: "50vh",
    [theme.breakpoints.down("sm")]: {
      marginTop: 20,
    },
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 18,
    borderRadius: 20,
    textTransform: "none",
    marginRight: 10,
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
  notificationStyle: {
    top: 80,
    right: 10,
  },
  tableCell: {
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
});
